import { render, staticRenderFns } from "./BindOffiaccountBox.vue?vue&type=template&id=4d41d6db&scoped=true"
import script from "./BindOffiaccountBox.vue?vue&type=script&lang=js"
export * from "./BindOffiaccountBox.vue?vue&type=script&lang=js"
import style0 from "./BindOffiaccountBox.vue?vue&type=style&index=0&id=4d41d6db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41d6db",
  null
  
)

export default component.exports